// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CurrentLang } from "../properties/Resources.js";

export let InstrumentType = function (message, dataCache)
{
    this.TypeId = message.TypeId;
    this.Id = message.TypeId;
    this.SuperTypeId = message.SuperTypeId;
    this.Name = message.TypeName;
    this.MinimalLot = message.MinimalLot;
    this.MaximalLot = message.MaximalLot;
    this.FDataCache = dataCache;
    this.FLanguageAliases = message.LanguageAliases || new Object();
    this.ExtendedFields = message.ExtendedFields || new Object();

    this._disclosedQuantityMinCoefficient = null
}

InstrumentType.prototype.DisplayName = function ()
{
    let alias = "";
    if (this.FLanguageAliases)
        alias = this.FLanguageAliases[CurrentLang];

    return alias || this.Name;
}

InstrumentType.prototype.toString = function ()
{
    return this.Name;
}

InstrumentType.prototype.DisclosedQuantityMinCoefficient = function ()
{
    if (this._disclosedQuantityMinCoefficient)
        return this._disclosedQuantityMinCoefficient

    if (!this.ExtendedFields)
        return null

    let result = this.ExtendedFields[InstrumentType.DISCLOSED_QUANTITY_MIN_COEFFICIENT_KEY]

    if (!result)
        return null

    this._disclosedQuantityMinCoefficient = parseFloat(result)

    return this._disclosedQuantityMinCoefficient;
}

InstrumentType.DISCLOSED_QUANTITY_MIN_COEFFICIENT_KEY = "Disclosed qty";